
import StateMachine from 'javascript-state-machine'
import store from './util/store'
import { asyncWrapper, detectOS } from '../common/common'
import HstWebSocket from './util/websocket'
import { EventResult, EventType, PubEventType, Protocol } from '../common/enums'
import protocolSender from './util/protocol-sender'
import logger from "../common/logger"
import mediaManager from "./media/media-manager"
import wbManager from "./media/white-board-manager"
import shareManager from "./media/share-manager"
import eventRegistry from '../common/event-registry'
import HeartController from 'util/heartController'

const heartController = new HeartController
/**
 * 主引擎状态机
 */
let RtcEngine = new StateMachine({
  init: 'uninit',
  transitions: [
    {name: 'doInit',        from: ['uninit', 'restoring'],    to: 'initing'},   // 初始化
    {name: 'initSuccess',   from: 'initing',                  to: 'inited'},    // 初始化成功
    {name: 'initFailed',    from: 'initing',                  to: 'uninit'},    // 初始化失败
    {name: 'doLogin',       from: 'inited',                   to: 'logining'},  // 登陆
    {name: 'loginSuccess',  from: 'logining',                 to: 'logined'},   // 登陆成功
    {name: 'loginFailed',   from: 'logining',                 to: 'inited'},    // 登陆失败
    {name: 'doJoin',        from: 'logined',                  to: 'joining'},   // 加入分组
    {name: 'joinSuccess',   from: 'joining',                  to: 'joined'},    // 加入分组成功
    {name: 'joinFailed',    from: 'joining',                  to: 'logined'},   // 加入分组失败
    {name: 'doLeave',       from: 'joined',                   to: 'leaving'},   // 离开分组
    {name: 'leaveSuccess',  from: 'leaving',                  to: 'logined'},   // 离开分组成功
    {name: 'leaveFailed',   from: 'leaving',                  to: 'joined'},    // 离开分组失败
    {name: 'doLogout',      from: ['logined', 'joined'],      to: 'logouting'}, // 退出登录
    {name: 'logoutSuccess', from: 'logouting',                to: 'inited'},    // 退出登录成功
    {name: 'logoutFailed',  from: 'logouting',                to: 'logined'},   // 退出登录失败
    {name: 'doDestroy',     from: ['logined', 'joined','inited', 'logining', 'joining', 'restoring', 'uninit', 'initing'], to: 'uninit'},    // 销毁
    {name: 'doRestore',     from: ['joined', 'logining', 'inited', 'logined'], to: 'restoring'}, // 断线重连  #2203
  ],
  data: {
    registered: false,
    forceLogouted: false,
    kickedOut: false
  },
  methods: {
    /**
     * websocket关闭
     */
    onWebSocketClosed() {
      logger.warn("Signalling websocket closed, state: " + this.state);

      if (store.websocket) {
        store.websocket.close()
        store.websocket = null
      }
      // TODO: 当前只处理joined状态
      if (!this.forceLogouted && !this.kickedOut) {
        // throw err
        eventRegistry.trigger('onWebSocketClosed')
        mediaManager.destroyPeerConnections() // 断开 peerconnection
        this.doRestore();
      }
    },

    /**
     * WebSocket连接成功
     */
    onWebSocketOpened() {
      let options = {
        appId: store.userInfo.appId,
        userId: store.userInfo.userId,
        token: store.loginParams.token,
        companyId: store.loginParams.companyId,
        osType: detectOS(),
        mutexType: store.loginParams.mutexType,
        forceLogin: store.loginParams.forceLogin,
        registered: store.loginParams.registered,
        extendInfo: store.loginParams.extendInfo
      }
      protocolSender.sendLoginReq(options);
    },



    /**
     * 离开分组处理
     */
    onLeaveGroup() {
      if (store.callGroupId && store.callGroupId == store.userInfo.groupId) {
        protocolSender.sendFinishCallReq(store.callId);
      }
      
      store.callGroupId = null;
      store.callId = null;
      store.userInfo.groupId = null;
      // 离开分组清楚定时器
      heartController.resetHeartBeat();
      mediaManager.init();
      mediaManager.destroyPeerConnections();
      wbManager.reinitialize();
      shareManager.destroyScreenShareStream();
    },

    /**
     * 登出处理
     */
    onLogout() {
      this.onLeaveGroup();
      store.userInfo.userId = null;
    },

    /**
     * 销毁引擎处理
     */
    onDestroy() {
      this.onLogout();

      store.userInfo.appId = null;
      store.userInfo.token = null;
      store.userInfo.companyId = null;
      
      if (store.websocket) {
        store.websocket.close();
        store.websocket = null;
      }
      // 离开分组清楚定时器
      heartController.resetHeartBeat();
      // 媒体管理器初始化
      mediaManager.init();
      // 协议缓存初始化
      protocolSender.init();
      // 断开所有peerconnection
      mediaManager.destroyPeerConnections();
      // 白板管理器数据初始化
      wbManager.reinitialize();

      shareManager.destroyScreenShareStream();
      // 数据重现初始化
      store.init();
    },

    //--------------------------------------------------------------------------
    // 协议处理
    //--------------------------------------------------------------------------
    
    /**
     * 登录响应
     * @params {*} msg 
     * @params {*} socket 
     */
    onLoginRes(msg, socket) {
      (msg.result == 0) ? this.loginSuccess() : this.loginFailed(msg.result);
    },

    /**
     * 登出响应
     * @params {*} msg 
     * @params {*} socket 
     */
    onLogoutRes(msg, socket) {
      (msg.result == 0) ? this.logoutSuccess() : this.logoutFailed();
    },

    /**
     * 加入分组响应
     * @params {*} msg 
     * @params {*} socket 
     */
    onJoinGroupRes(msg, socket) {
      (msg.result == 0) ? this.joinSuccess() : this.joinFailed();
    },

    /**
     * 离开分组响应
     * @params {*} msg 
     * @params {*} socket 
     */
    onLeaveGroupRes(msg, socket) {
      (msg.result == 0) ? this.leaveSuccess() : this.leaveFailed();
    },

    /**
     * 心跳响应
     * @param {*} msg 
     * @param {*} socket 
     */
    onHeartPacketRes(msg, socket) {
      heartController.resetHeartBeat().startHeartBeat(store.websocket.socket, () => {
        protocolSender.sendHeartPacket();
      }, 10000);
    },

    /**
     * 被强制登出
     * @params {*} msg 
     * @params {*} socket 
     */
    onForceLogout(msg, socket) {
      this.forceLogouted = true
      this.onLogout()
      eventRegistry.trigger("onUserForceLogout");
    },

    /**
     * 被踢出（登录）
     * @params {*} msg 
     * @params {*} socket 
     */
    onKickOut(msg, socket) {
      this.kickedOut = true;
      this.onLogout();
      protocolSender.sendKickOutRes(); // 直接回复消息
      eventRegistry.trigger("onKickOut");
    },
    
    //--------------------------------------------------------------------------
    // 状态机处理
    //--------------------------------------------------------------------------

    /**
     * 执行初始化
     * @params {*} lifecycle 
     * @params {*} params 
     */
    onDoInit: function(lifecycle, params) {
      if (!this.registered) {
        store.msgDispatcher.addMsgHandler(10001, this.onLoginRes.bind(this));
        store.msgDispatcher.addMsgHandler(10003, this.onLogoutRes.bind(this));
        store.msgDispatcher.addMsgHandler(10004, this.onForceLogout.bind(this));
        store.msgDispatcher.addMsgHandler(12007, this.onKickOut.bind(this));
        store.msgDispatcher.addMsgHandler(14101, this.onJoinGroupRes.bind(this));
        store.msgDispatcher.addMsgHandler(14103, this.onLeaveGroupRes.bind(this));
        store.msgDispatcher.addMsgHandler(Protocol.HEART, this.onHeartPacketRes.bind(this)); // 前端自定义心跳协议
        this.registered = true;
      }
      asyncWrapper(()=>{this.initSuccess()});
    },
    /**
     * 打印状态转移信息
     * @param {*} lifecycle 
     */
    onTransition(lifecycle) {
      logger.state("transition: " + lifecycle.transition + ", from " + lifecycle.from + " to " + lifecycle.to)
    },

    /**
     * 初始化成功
     * @params {*} lifecycle 
     * @params {*} params 
     */
    onInitSuccess: function(lifecycle, params) {
      if (!store.restoring) {
        eventRegistry.trigger(EventType.EVENT_INIT, EventResult.SUCCESS)
      } else {
        let params = {
          userId: store.userInfo.userId,
          appId: store.userInfo.appId,
          companyId: store.loginParams.companyId,
          token: store.loginParams.token,
          forceLogin: true, // 防止用户冲突
          mutexType: store.loginParams.mutexType,
          extendInfo: store.loginParams.extendInfo,
          accessUrl: store.loginParams.accessUrl
        }
        asyncWrapper(()=>{this.doLogin(params)})
      }
    },

    /**
     * 初始化失败
     * @params {*} lifecycle 
     * @params {*} params 
     */
    onInitFailed: function(lifecycle, params) {
      if (!store.restoring) {
        eventRegistry.trigger(EventType.EVENT_INIT, EventResult.FAILED);
      } else {
        store.restoring = false
        logger.warn("Restoring failed for init!")
      }
    },
    
    /**
     * 执行登录
     * @params {*} lifecycle 
     * @params {*} params 
     */
    onDoLogin: function(lifecycle, params) {
      if (!params.userId) {
        asyncWrapper(()=>{this.loginFailed("Invalid userId!")})
      } else {
        store.userInfo.userId = params.userId;
      }

      if (!params.appId) {
        asyncWrapper(()=>{this.loginFailed("Invalid appId!")})
      } else {
        store.userInfo.appId = params.appId;
      }

      if (!params.token) {
        asyncWrapper(()=>{this.loginFailed("Invalid token!")})
      } else {
        store.loginParams.token = params.token;
      }

      if (params.forceLogin) {
        store.loginParams.forceLogin = params.forceLogin ? 1 : 0;
      }

      if (params.extendInfo) {
        store.loginParams.extendInfo = params.extendInfo;
      }

      if (params.companyId) {
        store.loginParams.companyId = params.companyId;
      }

      if (params.mutexType) {
        store.loginParams.mutexType = params.mutexType;
      }

      let self = this;
      (async () => {
        try {
          // 如果没有指定Access地址，则默认使用公有云服务
          if (!params.accessUrl) {
            params.accessUrl = "https://access.paas.hst.com/server/address";
          }
          store.loginParams.accessUrl = params.accessUrl
          let wsAddr = ''
          try {
            wsAddr = await store.getSignalGateWay(params.accessUrl)
          } catch (err) {
            console.log(err)
            wsAddr = await store.getSignalGateWay(params.accessUrl)
          }
          let options = {
            addrUrl: wsAddr.indexOf(';') > -1 ? wsAddr.split(';') : [wsAddr],
            handler: store.msgDispatcher,
            opened() { self.onWebSocketOpened(); },
            closed() { self.onWebSocketClosed(); },
            error() { self.loginFailed("Websocket error!"); }
          };
          store.websocket = new HstWebSocket(options);
        } catch (err) {
          logger.error(err);
          self.loginFailed(err);
        }
      })();
    },

    /**
     * 登录成功
     * @params {*} lifecycle 
     * @params {*} params 
     */
    onLoginSuccess: function(lifecycle, params) {
      // 开始发送业务心跳
      heartController.resetHeartBeat().startHeartBeat(store.websocket.socket, () => {
        protocolSender.sendHeartPacket()
      }, 10000)
      if (!store.restoring) {
        eventRegistry.trigger(EventType.EVENT_LOGIN, EventResult.SUCCESS);
      } else {
        if (store.userInfo.groupId !== null) {
          asyncWrapper(()=>{this.doJoin(store.userInfo.groupId)})
        } else {
          store.restoring = false
          logger.log('restore success!')
        }
      }
    },

    /**
     * 登录失败
     * @params {*} lifecycle 
     * @params {*} params 
     */
    onLoginFailed: function(lifecycle, params) {
      if (!store.restoring) {
        eventRegistry.trigger(EventType.EVENT_LOGIN, EventResult.FAILED);
      } else {
        store.restoring = false
        eventRegistry.trigger(PubEventType.PUB_EVENT_ERROR, {
          code: 101,
          reason: 'Restoring failed for login!'
        });
        logger.warn("Restoring failed for login!")
      }
    },

    /**
     * 执行加入分组
     * @params {*} lifecycle 
     * @params {*} params 
     */
    onDoJoin: function(lifecycle, params) {
      protocolSender.sendJoinGroupReq(params);
      store.userInfo.groupId = params;
    },

    /**
     * 加入分组成功
     * @params {*} lifecycle 
     * @params {*} params 
     */
    onJoinSuccess: function(lifecycle, params) {
      if (!store.restoring) {
        eventRegistry.trigger(EventType.EVENT_JOIN_GROUP, EventResult.SUCCESS);
      } else {
        // store.restoring = false
        // 断线重连后重新发布消息
        mediaManager.tryRestoreSendMsg()
        logger.log("Restoring success.")
      }
    },

    /**
     * 加入分组失败
     * @params {*} lifecycle 
     * @params {*} params 
     */
    onJoinFailed: function(lifecycle, params) {
      if (!store.restoring) {
        eventRegistry.trigger(EventType.EVENT_JOIN_GROUP, EventResult.FAILED);
      } else {
        store.restoring = false
        logger.warn("Restoring failed for join group!")
      }
    },

    /**
     * 执行离开分组
     * @params {*} lifecycle 
     * @params {*} params 
     */
    onDoLeave: function(lifecycle, params) {
      // fixed bug  退出分组取消发布所有广播的消息
      mediaManager.cachePublicMsg.forEach((value) => {
        mediaManager.stopPublishMedia(...value)
      })
      protocolSender.sendLeaveGroupReq();
    },

    /**
     * 离开分组成功
     * @params {*} lifecycle 
     * @params {*} params 
     */
    onLeaveSuccess: function(lifecycle, params) {
      this.onLeaveGroup();
      eventRegistry.trigger(EventType.EVENT_LEAVE_GROUP, EventResult.SUCCESS);
    },

    /**
     * 离开分组失败
     * @params {*} lifecycle 
     * @params {*} params 
     */
    onLeaveFailed: function(lifecycle, params) {
      eventRegistry.trigger(EventType.EVENT_LEAVE_GROUP, EventResult.FAILED);
    },

    /**
     * 执行登出
     * @params {*} lifecycle 
     * @params {*} params 
     */
    onDoLogout: function(lifecycle, params) {
      // fixed bug  退出分组取消发布所有广播的消息
      mediaManager.cachePublicMsg.forEach((value) => {
        mediaManager.stopPublishMedia(...value)
      })
      protocolSender.sendLogoutReq();
    },

    /**
     * 登出成功
     * @params {*} lifecycle 
     * @params {*} params 
     */
    onLogoutSuccess: function(lifecycle, params) {
      this.onLogout();
      eventRegistry.trigger(EventType.EVENT_LOGOUT, EventResult.SUCCESS);
    },

    /**
     * 登出失败
     * @params {*} lifecycle 
     * @params {*} params 
     */
    onLogoutFailed: function(lifecycle, params) {
      eventRegistry.trigger(EventType.EVENT_LOGOUT, EventResult.FAILED);
    },

    /**
     * 销毁引擎
     * @params {*} lifecycle 
     * @params {*} params 
     */
    onDoDestroy: function(lifecycle, params) {
      this.onDestroy();
    },

    /**
     * 断线重连
     * @param {*} lifecycle 
     * @param {*} params 
     */
    onRestoring: function(lifecycle, params) {
      store.restoring = true
      asyncWrapper(()=>{this.doInit()})
    }
  }
});

export default RtcEngine;
